<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="订单编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'ddCode', validatorRules.ddCode]" placeholder="请输入订单编号"></a-input>
        </a-form-item>
        <a-form-item label="文件地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'fileUrl', validatorRules.fileUrl]" placeholder="请输入文件地址"></a-input>
        </a-form-item>
        <a-form-item label="文件类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'fileType', validatorRules.fileType]" placeholder="请输入文件类型"></a-input>
        </a-form-item>
        <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择创建时间" v-decorator="[ 'createTime', validatorRules.createTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="创建人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'createBy', validatorRules.createBy]" placeholder="请输入创建人"></a-input>
        </a-form-item>
        <a-form-item label="修改时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择修改时间" v-decorator="[ 'updateTime', validatorRules.updateTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="修改人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'updateBy', validatorRules.updateBy]" placeholder="请输入修改人"></a-input>
        </a-form-item>
        <a-form-item label="删除标志" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'delFlag', validatorRules.delFlag]" placeholder="请输入删除标志" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="作者" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'author', validatorRules.author]" placeholder="请输入作者"></a-input>
        </a-form-item>
        <a-form-item label="文件来源(1:绘图,2:文件上传,3:检查未上传订单定时器执行,4:泗阳传入)" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'fileSource', validatorRules.fileSource]" placeholder="请输入文件来源(1:绘图,2:文件上传,3:检查未上传订单定时器执行,4:泗阳传入)" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="文件原来的名字" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'fileOldName', validatorRules.fileOldName]" placeholder="请输入文件原来的名字"></a-input>
        </a-form-item>
        <a-form-item label="上传到对象存储的文件名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'fileNewName', validatorRules.fileNewName]" placeholder="请输入上传到对象存储的文件名"></a-input>
        </a-form-item>
        <a-form-item label="操作" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'operation', validatorRules.operation]" placeholder="请输入操作"></a-input>
        </a-form-item>
        <a-form-item label="组织编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'sysOrgCode', validatorRules.sysOrgCode]" placeholder="请输入组织编码"></a-input>
        </a-form-item>
        <a-form-item label="上传描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'uploadDescribe', validatorRules.uploadDescribe]" placeholder="请输入上传描述"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: "OrderOperationRecordListModal",
    components: { 
      JDate,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          ddCode: {rules: [
          ]},
          fileUrl: {rules: [
          ]},
          fileType: {rules: [
          ]},
          createTime: {rules: [
          ]},
          createBy: {rules: [
          ]},
          updateTime: {rules: [
          ]},
          updateBy: {rules: [
          ]},
          delFlag: {rules: [
          ]},
          author: {rules: [
          ]},
          fileSource: {rules: [
          ]},
          fileOldName: {rules: [
          ]},
          fileNewName: {rules: [
          ]},
          operation: {rules: [
          ]},
          sysOrgCode: {rules: [
          ]},
          uploadDescribe: {rules: [
          ]},
        },
        url: {
          add: "/factory.base/orderUploadOperationRecord/add",
          edit: "/factory.base/orderUploadOperationRecord/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'ddCode','fileUrl','fileType','createTime','createBy','updateTime','updateBy','delFlag','author','fileSource','fileOldName','fileNewName','operation','sysOrgCode','uploadDescribe'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'ddCode','fileUrl','fileType','createTime','createBy','updateTime','updateBy','delFlag','author','fileSource','fileOldName','fileNewName','operation','sysOrgCode','uploadDescribe'))
      },

      
    }
  }
</script>